// extracted by mini-css-extract-plugin
export var actionButton = "_q3-0";
export var actionMenuContainer = "_q3-i";
export var bubble = "_q3-2";
export var bubbleActionMenu = "_q3-j";
export var bubbleContext = "_q3-6";
export var bubbleItems = "_q3-7";
export var customer = "_q3-3";
export var divider = "_q3-8";
export var fileList = "_q3-9";
export var hiddenComment = "_q3-o";
export var infoAbove = "_q3-a";
export var internal = "_q3-4";
export var lightActionButton = "_q3-1";
export var link = "_q3-b";
export var merchant = "_q3-5";
export var message = "_q3-c";
export var profilePicture = "_q3-e";
export var quillToolbarContainer = "_q3-f";
export var senderDate = "_q3-g";
export var senderDateCustomer = "_q3-h";
export var senderName = "_q3-d";
export var time = "_q3-k";
export var uploadedImage = "_q3-l";
export var username = "_q3-m";
export var xsmall = "_q3-n";